import { ReactNode } from "react"


type WarningTextType = 'warning' | 'error' | 'attention'

type WarningTextProps = {
  type?: WarningTextType
  text: string
  children?: ReactNode
}

// 'attention' is red rather than the amber of 'warning': a document showing an
// amount from before the change is a different class of problem from an
// unapplied transaction, and the two chips can appear side by side.
const labelClass: Record<WarningTextType, string> = {
  warning: 'warning-label',
  error: 'error-label',
  attention: 'attention-label',
}

const labelText: Record<WarningTextType, string> = {
  warning: 'Warning:',
  error: 'Error:',
  attention: 'Attention:',
}

export default function WarningText({ type = 'warning', text, children }: WarningTextProps) {
  return (
    <div className='warning-text-container'>
      <div className='warning-text-wrapper'>
        <div className={labelClass[type]}>{labelText[type]} </div>
        <div className='warning-text'>{text}</div>
      </div>
      {children && <div className='warning-children-container'>{children}</div>}
    </div>
  )
}